import { STAGES, OVERDUE_FILL } from "@/lib/growthLogic";

export function ProgressBar({ segmentsFilled, overdue }) {
  const segments = Array.from({ length: 7 });
  return (
    <div className="flex w-full h-2.5 gap-1" data-testid="progress-bar">
      {segments.map((_, idx) => {
        const filled = idx < segmentsFilled;
        let cls = "bg-stone-100";
        if (filled) {
          cls = overdue && idx === 6 ? OVERDUE_FILL : STAGES[idx].fill;
        }
        return (
          <div
            key={STAGES[idx].key}
            data-testid={`progress-segment-${idx}`}
            className={`h-full flex-1 rounded-full transition-colors duration-500 ${cls}`}
            title={STAGES[idx].label}
          />
        );
      })}
    </div>
  );
}
